import React from "react";
import { getPaymentLogs } from "services/merchant.service";
import styled from "styled-components";
import { modifiedFormatMoney } from "utils/money";
import { Button, Spin} from "antd";
import { format, parseISO } from "date-fns";
import { useNavigate } from "react-router-dom";

const TransactionTable = styled.div`
  width: 100%;
`;

const Col = styled.div`
  width: 25%;
`;

const TableBody = styled.div`
  overflow: hidden;
  overflow-y: auto;
`;

const GreyContainer = styled.div`
  color: #4d4d4d;
  font-size: 12px;
  display: flex;
`;

const TransactionHeader = styled.table`
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;;

  p {
    margin-bottom: 0.5rem;
  }
`;

const RecipientExpense = styled.div`
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;;

  p {
    margin-bottom: 0.5rem;
  }
`;

const RecipientSection = styled.div`
  border-top: 0.5px solid #979797;
`;

const CenterDiv = styled.div`
  display: flex;
  justify-content: center;
`;

const LoadPageSection = styled(CenterDiv)`
  margin-top: 1rem;
  margin-bottom: 1rem;

  button {
    border-radius: 11px;
    background-color: #a7beffff;

    &:hover {
      background: #dbe0ffff;
    }

    span {
      color: white;
    }
  }
`;

const PaymentLogs = () => {
  const [logs, setLogs] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [hasMore, setHasMore] = React.useState(false);
  const [page, setPage] = React.useState(1);

  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("qrUser"));

  const fetchTransactions = async (pageNumber) => {
    setLoading(true);
    const res = await getPaymentLogs(user?.id, pageNumber);

    const newItems = res?.results;

    if (pageNumber === 1) {
      setLogs(newItems || []);
    } else if (newItems?.length) {
      setLogs(prevLogs => [...prevLogs, ...newItems]);
    }

    if (res?.next) {
      setHasMore(true);
    } else {
      setHasMore(false);
    }

    setLoading(false);
  };

   const loadNextPage = () => {
    if (!loading && hasMore) {
      setPage(prevPage => prevPage + 1);
    }
  };

  const prevPageRef = React.useRef();

  React.useEffect(() => {
    if (user?.id) {
      if (prevPageRef.current !== page) {
        fetchTransactions(page);
        prevPageRef.current = page;
      }
    }
  }, [page, user]);

  return (
    <TransactionTable>
      <TransactionHeader>
        <Col style={{ textAlign: "start" }}>
          <h4>Transaction</h4>
        </Col>
        <Col>
          <h4>Amount</h4>
        </Col>
      </TransactionHeader>

      <TableBody>
        {logs?.map(log => (
          <RecipientSection
            key={log.id}
            onClick={() =>
              log?.type === "payment"
                ? navigate(`/merchant/payments/${log.id}`, { state: { log } })
                : navigate(`/merchant/transactions/${log.id}`)
            }
          >
            <RecipientExpense>
              <Col style={{ textAlign: "left" }}>
                <GreyContainer>
                  {log?.type === "payment" ? "Received From" : "Redeemed By"}
                </GreyContainer>
                <p>{log?.name}</p>
              </Col>
              <Col>
                <p>
                  {log?.type === "payment" ? (
                    <span style={{ color: "#1ba833", fontWeight: "bold" }}>
                      +{modifiedFormatMoney(log?.amount || 0)}
                    </span>
                  ) : (
                    modifiedFormatMoney(log?.amount || 0)
                  )}
                  <br />
                  {log.created_at && (
                    <GreyContainer>
                      {format(parseISO(log.created_at), "MMM dd, yyyy")}
                    </GreyContainer>
                  )}
                </p>
              </Col>
            </RecipientExpense>
          </RecipientSection>
        ))}

        {hasMore && !loading && (
          <LoadPageSection>
            <Button onClick={() => loadNextPage()}>load more</Button>
          </LoadPageSection>
        )}

        {loading && (
          <CenterDiv>
            <Spin />
          </CenterDiv>
        )}
      </TableBody>
    </TransactionTable>
  );
};

export default PaymentLogs;
